import { ref } from "vue";

export interface AppNotification {
    id: string;
    title: string;
    message: string;
    createdAt: string;
    read: boolean;
    // Optional navigation target and payload
    routePath?: string;
    routeQuery?: Record<string, any>;
    downloadUrl?: string;
    type?: string;
}

const notifications = ref<AppNotification[]>([]);

function addNotification(n: Omit<AppNotification, 'id' | 'createdAt' | 'read'>) {
    const id = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    notifications.value.unshift({
        id,
        title: n.title,
        message: n.message,
        routePath: n.routePath,
        routeQuery: n.routeQuery,
        downloadUrl: n.downloadUrl,
        type: n.type,
        createdAt: new Date().toISOString(),
        read: false,
    });
}

function markAllRead() {
    notifications.value.forEach(n => n.read = true);
}

function markRead(id: string) {
    const n = notifications.value.find(x => x.id === id);
    if (n) n.read = true;
}

const unreadCount = () => notifications.value.filter(n => !n.read).length;

export function notificationsStore() {
    return {
        notifications,
        unreadCount,
        addNotification,
        markAllRead,
        markRead,
    };
}







